/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_Lofty_Skate_ZoomInputs */

const fr_fit_lofty_skate_zoom = /** @type {(inputs: Fit_Lofty_Skate_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Fit_Lofty_Skate_ZoomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fit_lofty_skate_zoom = /** @type {((inputs?: Fit_Lofty_Skate_ZoomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_Lofty_Skate_ZoomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fit_lofty_skate_zoom(inputs)
});